(function () {
	const announcementSlider = () => {
		$(".announcement-bar__slide").each(function () {
			if ($(this).hasClass("slider_started")) {
				return; // Skip already initialized sliders
			}
			if ($(".announcement-bar").hasClass("announcement__slide-show")) {
				$(this).addClass("slider_started");
			}

			const announcementId = $(this).data("announcement-id");
			const announcementSpeed = $(this).data("announcement-speed") * 1000;

			// Ensure at least 2 slides for looping
			const slideWrapper = $(this).find(".swiper-wrapper");
			const slides = slideWrapper.find(".swiper-slide");
			if (slides.length < 2) {
				const slideContent = slides.eq(0).html();
				slideWrapper.append(`<div class="swiper-slide">${slideContent}</div>`); // Duplicate the slide if only one exists
			}

			// Initialize the Swiper instance
			new Swiper(`.announcement-js-${announcementId}`, {
				slidesPerView: "auto",
				speed: announcementSpeed,
				initialSlide: 0,
				loop: true,
				loopedSlides: slides.length, // Dynamically match the actual number of slides
				allowTouchMove: true,
				waitForTransition: false,
				watchSlidesProgress: false,
				autoplay: {
					delay: 0,
					disableOnInteraction: false,
				},
			});
		});
	};

	const checkWindow = () => {
		if ($(window).width() < 576) {
			$(".announcement-bar").addClass("announcement__slide-show");
			announcementSlider();
		} else {
			$(".announcement-bar__slide").removeClass("slider_started");
			$(".announcement-bar").removeClass("announcement__slide-show");
		}
	};

	checkWindow();

	// Bind resize event to handle window size changes
	$(window).resize(function () {
		checkWindow();
	});

	// Initialize slider on page load
	announcementSlider();

	// Reinitialize on Shopify section load
	document.addEventListener("shopify:section:load", function () {
		$(".announcement-js").each(function () {
			if (this.swiper) {
				this.swiper.destroy(true, true); // Destroy existing Swiper instance
			}
		});
		announcementSlider();
	});

	// Reinitialize when visibility changes (e.g., tab focus change)
	document.addEventListener("visibilitychange", function () {
		if (!document.hidden) {
			$(".announcement-js").each(function () {
				if (this.swiper) {
					this.swiper.destroy(true, true); // Destroy existing Swiper instance
				}
			});
			announcementSlider();
		}
	});
})();
